<div class="switcher" [class.checked]="value">
  <input
    [id]="formControlName || id"
    [(ngModel)]="value"
    [disabled]="disable"
    [tabindex]="tabInd"
    type="checkbox"
    name="switcher"
    id="switcher-{{id}}"
    class="switcher-input"
  />

  <label
    [class.disabled]="disable"
    [for]="formControlName || id"
    class="switcher-label"
  ></label>

  <ng-content></ng-content>
</div>
